import { defineStore } from 'pinia'

export const useProfileStore = defineStore({
    id: 'profile',

    state () {
        return {
            closing: false,
            opening: false,
            modelName: null,
            modelId: null,
            anchorId: null,
            placement: null,
            ddName: 'profile-informer',

            profile: null,

            activeSubMenu: [
                {menu: 'courses', submenu: "design"}
            ]
        }
    },

    actions: {
        async open ({id, value}) {
            this.opening = true;
            this.anchorId = id;
    
            if (value && value.placement) this.placement = value.placement;
            if (value && value.fallbackPlacements) this.fallbackPlacements = value.fallbackPlacements;
    
            setTimeout(async () => {
                // If element lost hover or another element was hovered
                if (!this.opening || id != this.anchorId) return;
    
                if (
                    value.modelName != this.modelName ||
                    value.modelId   != this.modelId
                ) {
                    let res = await this.$nuxt.$axios.$get(
                        `/${value.modelName}/businesscard/${value.modelId}`,
                        {progress: false}
                    )
                    .catch(err => {console.log(err)});
    
                    if (!res || !res.author) return;

                    this.modelId   = value.modelId;
                    this.modelName = value.modelName;
                    this.profile   = res;
                }
    
                this.setClosing = false;
                this.$nuxt.$modalityStore.openDropdown({
                    name: this.ddName, 
                    id: id
                });
    
    
                this.$nuxt.$gtag('event', 'profile_card', {
                    type: value.modelName
                })
            }, 700)
        },
        
        // TODO is it really have to be here?
        continue () {
            this.closing = false;
        },
    
        close () {
            this.closing = true;
            this.opening = false;
    
            setTimeout(() => {
                if (this.closing) {
                    this.$nuxt.$modalityStore.closeDropdown({name: this.ddName});
                }
            }, 300)
        }
    }
});
